import { useRef, useEffect } from 'react'
import PulseLoader from 'react-spinners/PulseLoader'
import { MainContainer } from './loadingOverlay_styles'

const LoadingOverlay = ({ visible }) => {
  const showTimerRef = useRef()
  const hideTimerRef = useRef()
  const dialogRef = useRef()

  useEffect(() => {
    clearTimers()

    if (visible) {
      showTimerRef.current = setTimeout(() => {
        try {
          dialogRef.current?.showModal()
        }
        catch (error) {
          console.error(error)
        }
      }, 500)
    }
    else {
      hideTimerRef.current = setTimeout(() => {
        dialogRef.current?.close()
      }, 250)
    }

    return () => {
      clearTimers()
    }
  }, [visible])

  const clearTimers = () => {
    if (showTimerRef.current) {
      clearTimeout(showTimerRef.current)
      showTimerRef.current = null
    }
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current)
      hideTimerRef.current = null
    }
  }

  return (
    <MainContainer ref={dialogRef} aria-label='loading'>
      <PulseLoader
        loading={true}
        color='#F1EAE3'
      />
    </MainContainer>
  )
}

export default LoadingOverlay
